import { render, staticRenderFns } from "./rcSesLimitationsIndex.vue?vue&type=template&id=19684705&scoped=true&"
import script from "./rcSesLimitationsIndex.vue?vue&type=script&lang=js&"
export * from "./rcSesLimitationsIndex.vue?vue&type=script&lang=js&"
import style0 from "./rcSesLimitationsIndex.vue?vue&type=style&index=0&id=19684705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19684705",
  null
  
)

export default component.exports